// extracted by mini-css-extract-plugin
export default {"page":"page_page__FXK+R","page_content":"page_page_content__7Abnw","title":"page_title__tDuXb"};